import { useMutation } from 'react-query';

import { postCheckout } from '@src/requests/cartItems';

const useCheckout = (config = {}) => {
    return useMutation(
        postCheckout,
        config,
    );
};

export {
    useCheckout,
};
